import React from 'react';
import MediaQuery from 'react-responsive';
import { AboutRole } from 'components/organisms/aboutRole';
import AboutRoleMobileView from 'components/organisms/aboutRoleMobile';

const AboutRoleSection = props => {
  const { data } = props;
  return (
    <div id={'about-the-role'}>
      <MediaQuery minDeviceWidth={576}>
        <AboutRole
          data={data.specificJobData}
          roleName={data.roleName && data.roleName}
        />
      </MediaQuery>
      <MediaQuery maxDeviceWidth={575.6}>
        <AboutRoleMobileView
          data={data.specificJobData}
          roleName={data.roleName && data.roleName}
        />
      </MediaQuery>
    </div>
  );
};

export default AboutRoleSection;
